import { render, staticRenderFns } from "./ConceptoForm.vue?vue&type=template&id=32bafa08&scoped=true"
import script from "./ConceptoForm.vue?vue&type=script&lang=js"
export * from "./ConceptoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bafa08",
  null
  
)

export default component.exports